import { useState, useEffect } from 'react';
//import CommentBox from '../../../components/CommentBox/CommentBox';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import axios from 'axios';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Abhijit.scss';
import MuhuratLink from '../../../components/MuhuratLink/MuhuratLink';
import city from '../../../city.json'

const Abhijit = () => {

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  

  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata");
  const [timeFormat, setTimeFormat] = useState("12"); // "12", "24", or "24Plus"
 const [abhijit, setAbhijit] = useState(null);

  // Temporary states for user input for submit button
const [tempDate, setTempDate] = useState(currentDate);
const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);


  useEffect(() => {
    const fetchAbhijitData= async () => {

      const formattedDate = currentDate.toISOString().split('T')[0];

      if (!location || location.trim() === '') return;
      try {
        const res = await axios.get(`https://core-c343.onrender.com/api/panchanga?date=${formattedDate}&location=${location}`);
        
        // Safely extract rahuKalam
       if (res.data && res.data.muhurta && res.data.muhurta.abhijit) {
          setAbhijit(res.data.muhurta.abhijit);
           }else {
              console.error("abhijit data not found in response");
            }

      } catch (err) {
        console.error("Failed to fetch abhijit data:", err);
      }
    };

    fetchAbhijitData();
  }, [currentDate, location]);

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };


  const convertTime = (timeStr) => {
    const [start, end] = timeStr.split("to");
    const format = (t) => {
      let [h, m] = t.split(":");
      h = parseInt(h);
      m = m || "00";
      if (timeFormat === "12") {
        const ampm = h >= 12 ? "PM" : "AM";
        h = h % 12 || 12;
        return `${String(h).padStart(2, "0")}:${m} ${ampm}`;
      } else if (timeFormat === "24") {
        return `${String(h).padStart(2, "0")}:${m}`;
      } else {
        return `${t}`;
      }
    };
    return `${format(start)} to ${format(end)}`;
  };

  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });



  function convertUtcToIstTimeOnly(utcTimeStr, mode = '12') {
  if (!utcTimeStr) return 'N/A';

  const [time, modifier] = utcTimeStr.trim().split(' ');
  let [hours, minutes] = time.split(':').map(Number);

  if (modifier.toUpperCase() === 'PM' && hours !== 12) hours += 12;
  if (modifier.toUpperCase() === 'AM' && hours === 12) hours = 0;

  const today = new Date();
  const date = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), hours, minutes));

  const options = {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    hour12: mode === '12',
  };

  return date.toLocaleTimeString('en-IN', options);
}


const formatTime = (timeStr, mode = "12") => {
  if (!timeStr || typeof timeStr !== "string") return "N/A";

  const [hour, minute, second] = timeStr.split(":").map(Number);

  if (mode === "12") {
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${suffix}`;
  }

  if (mode === "24") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
  }

  if (mode === "24+") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}:${second.toString().padStart(2, "0")}`;
  }

  return timeStr;
};


  return (
    <div className="Abhijit-container">
      <InnerNav />
      <div className="Abhijit-content">
        <Zodiac />
        <div className="Abhijit-details">
                <div className="title">Abhijit Muhurat</div>
                {/* <div className="sub">Running Do Ghati Muhurat</div> */}
              <div className="header">
                <div className="img-details">
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW3C3Ty79k_gyPc3OD5oWmoWQk5nXn1bGIYQ&s" alt="err" />
                  <div className="right">
                    <p>Abhijit Muhurat</p>
                    <p>{readableDate}</p>
                    <p>{abhijit?.start} - {abhijit?.end}</p>
                   
                  </div>
                </div>
                <div className="date-display">
                  <span className="day">{currentDate.getDate()}</span>
                  <span className="month">{readableDate}</span>
                </div>
              </div>

              <div className="controls">
                <div className="mode-toggle">
                  <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
                  <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
                  <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
                </div>

                <div className="month-grid">
                  {months.map((month, i) => (
                    <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
                  ))}
                </div>

                <div className="day-grid">
                  {Array.from({ length: 31 }, (_, i) => (
                    <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
                  ))}
                </div>

                <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
              </div>

              <div className="muhurta-section">
                <div className="muhurta-header">
                  <div className="muhurta-date">{readableDate}, {weekDay}</div>
                </div>


                   {abhijit ? (
                      <div className="Abhijit-card">
                        <div className="Abhijit-header">
                          <h3>Abhijit Muhurat Timing</h3>
                          <p>{readableDate}</p> {/* If you still want to show today's date */}
                        </div>
                        <div className="Abhijit-img">
                          <img
                            src="https://bcdn.mpanchang.com/images/social/Abhijit-Muhurat.jpg"
                            alt="abhijit"
                          />
                        </div>
                        <div className="Abhijit-data">
                          <h3>{formatTime(abhijit.start, timeFormat)} to {formatTime(abhijit.end, timeFormat)}</h3>
                          {/* <p>Duration: {calculateDuration(rahuKalam.start, rahuKalam.end)}</p> */}

                        </div>
                      </div>
                    ) : (
                      <p>No abhijit muhurat data available for today.</p>
                    )}
              </div>
            </div>

              <section className="abhijit-wrapper">
      <h1 className="abhijit-title">About Abhijit Muhurat</h1>
      <div className="abhijit-texts">
        <p>
          Abhijit Muhurat is auspicious time during midday which approximately lasts for 48 minutes. Abhijit Muhurat is capable of destroying innumerable Doshas and it is considered one of the best Muhurats to start all sort of auspicious works. Abhijit Muhurat is a powerful election and can be chosen for day-to-day life activities without going into intricacies of finding a suitable Muhurat for the day.
        </p>

        <p>
          Abhijit Muhurat is the 8th Muhurat out of 15 Muhurats which prevail between the sunrise and the sunset. The time interval between the sunrise and the sunset is divided into 15 equal parts and the middle portion of fifteen parts is known as Abhijit Muhurat.
        </p>

        <p>
          If the sunrise occurs at 6 a.m. and the sunset occurs at 6 p.m. for a particular location then Abhijit Muhurat would start exactly 24 minutes before midday and would end after 24 minutes of midday. In other words Abhijit Muhurat for such a location would be between 11:40 a.m. to 12:20 p.m. of the day. Due to seasonal change of sunrise and sunset timings, the exact time and duration of Abhijit Muhurat is not fixed.
        </p>

        <p>
          It is believed that Lord Shiva killed demon Tripurasur during Abhijit Muhurat. Further, Abhijit Muhurat has blessing of Lord Vishnu who destroys innumerable Doshas with His Sudarshan Chakra during the currency of this Muhurat.
        </p>

        <p>
          Abhijit Muhurat is also known as Abhijin Muhurat, Chaturtha Lagna, Kutub Muhurat, and Swami Tithiyansha Muhurat. Muhurat is also spelled as Muhurta and muhurtham. The counter part of Abhijit Muhurat is Nishita Kaal which prevails during midnight.
        </p>

        <p>
          It should be noted that Abhijit Muhurat is not suitable on Wednesday as it forms a malefic Muhurta on this weekday. Abhijit Muhurat is also not suitable for Manglik activities like marriage and Upanayana ceremonies.
        </p>
      </div>
    </section>
        <MuhuratLink/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Abhijit;
